import {range} from 'lodash';
import {Matrix, UnsavedMatrix} from './types';
import {cloneDeep} from 'lodash';

export const days = range(0, 7);
export const hours = range(0, 24);

export const INITIAL_MATRIX: Matrix = cloneDeep(
  days.map(() => hours.map((_) => [{length: 60, speed: 0}])),
);

export const colors = new Map([
  [0, '#FFFFFF'],
  [5, '#B6B6B6'],
  [10, '#A4A4A4'],
  [15, '#87E085'],
  [20, '#5FD65C'],
  [25, '#37CC33'],
  [30, '#76D5EF'],
  [35, '#48C7EA'],
  [40, '#1AB9E5'],
  [45, '#FABE76'],
  [50, '#F9A948'],
  [55, '#F7931A'],
  [60, '#8EB6F8'],
  [65, '#689DF6'],
  [70, '#4285F4'],
  [75, '#C685E0'],
  [80, '#B35CD6'],
  [85, '#A033CC'],
  [90, '#FA8D92'],
  [95, '#F9686E'],
  [100, '#F74249'],
]);

export const timezones = [
  {name: 'UTC-12:00', offset: -12},
  {name: 'UTC-11:00', offset: -11},
  {name: 'UTC-10:00', offset: -10},
  {name: 'UTC-09:30', offset: -9.5},
  {name: 'UTC-09:00', offset: -9},
  {name: 'UTC-08:00', offset: -8},
  {name: 'UTC-07:00', offset: -7},
  {name: 'UTC-06:00', offset: -6},
  {name: 'UTC-05:00', offset: -5},
  {name: 'UTC-04:00', offset: -4},
  {name: 'UTC-03:30', offset: -3.5},
  {name: 'UTC-03:00', offset: -3},
  {name: 'UTC-02:00', offset: -2},
  {name: 'UTC-01:00', offset: -1},
  {name: 'UTC±00:00', offset: 0},
  {name: 'UTC+01:00', offset: 1},
  {name: 'UTC+02:00', offset: 2},
  {name: 'UTC+03:00', offset: 3},
  {name: 'UTC+03:30', offset: 3.5},
  {name: 'UTC+04:00', offset: 4},
  {name: 'UTC+04:30', offset: 4.5},
  {name: 'UTC+05:00', offset: 5},
  {name: 'UTC+05:30', offset: 5.5},
  {name: 'UTC+05:45', offset: 5.75},
  {name: 'UTC+06:00', offset: 6},
  {name: 'UTC+06:30', offset: 6.5},
  {name: 'UTC+07:00', offset: 7},
  {name: 'UTC+08:00', offset: 8},
  {name: 'UTC+08:45', offset: 8.75},
  {name: 'UTC+09:00', offset: 9},
  {name: 'UTC+09:30', offset: 9.5},
  {name: 'UTC+10:00', offset: 10},
  {name: 'UTC+10:30', offset: 10.5},
  {name: 'UTC+11:00', offset: 11},
  {name: 'UTC+12:00', offset: 12},
  {name: 'UTC+12:45', offset: 12.75},
  {name: 'UTC+13:00', offset: 13},
  {name: 'UTC+14:00', offset: 14},
];

export const INITIAL_UNSAVED_MATRIX: UnsavedMatrix = cloneDeep(
  days.map(() => hours.map((_) => null)),
);

export const USER_TIMEZONE_MINUTES = -new Date().getTimezoneOffset();

export const EMPTY_TIMELINE = cloneDeep(Array(7 * 24 * 60).fill(0));
